import React, { useState, useEffect, useRef } from 'react';
import { Row, Col } from 'reactstrap';
//import { models, Report, Embed, IEmbedConfiguration, service, Page } from 'powerbi-client';
import * as pbi from 'powerbi-client';
import { PowerBIEmbed } from 'powerbi-client-react';
import { getEmbedConfig } from '../../API';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExpand, faCompress } from '@fortawesome/free-solid-svg-icons'

function Reports(props) {
    const [embedConfig, setEmbedConfig] = useState(null);
    const [report, setReport] = useState(null);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const [isMaximzed, setIsMaximized] = useState(false);
    const reportContainer = useRef(null);

    useEffect(() => {
        document.addEventListener('fullscreenchange', updateFullscreen);
        setupPowerBI();

        return () => document.removeEventListener('fullscreenchange', updateFullscreen);
    }, []);

    const setupPowerBI = async () => {
        const params = {
            workspaceId: window.env.powerBi.workspaceId, //'164b15b5-e7c0-438f-8a37-0d2189489f5a',
            reportId: window.env.powerBi.reportId //'a958628b-9c4f-4fd1-9762-e34dbdee9283'
        };
        const embedInfo = await getEmbedConfig(params);
        if (embedInfo !== null && embedInfo.errorMessage === null) {
            setEmbedConfig({
                type: 'report',   // Supported types: report, dashboard, tile, visual and qna
                id: embedInfo.reportID,
                embedUrl: embedInfo.embedUrl,
                accessToken: embedInfo.embedToken.token,
                permissions: pbi.models.Permissions.All,
                tokenType: pbi.models.TokenType.Embed
            });

        } else { //Hanlde errors
            console.log(embedInfo?.errorMessage)
        }
    }

    const eventHandlers = new Map([
        ['loaded', function () { console.log('Report loaded'); }],
        ['rendered', function () { console.log('Report rendered'); }],
        ['error', function (event) { console.log(event.detail); }]
    ]);

    const getEmbeddedComponent = (embeddedReport) => {
        setReport(embeddedReport);
    };

    const toggleMaximized = () => setIsMaximized(!isMaximzed);

    const openFullscreen = () => {
        if (reportContainer.current.requestFullscreen) {
            reportContainer.current.requestFullscreen();
        } else if (report.element.webkitRequestFullscreen) { /* Safari */
            reportContainer.current.webkitRequestFullscreen();
        } else if (report.element.msRequestFullscreen) { /* IE11 */
            reportContainer.current.msRequestFullscreen();
        }
    }

    function closeFullscreen() {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.webkitExitFullscreen) { /* Safari */
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) { /* IE11 */
            document.msExitFullscreen();
        }
    }

    const updateFullscreen = () => {
        if (document.fullscreenElement || document.webkitFullscreenElement ||
            document.mozFullScreenElement)
            setIsFullscreen(true);
        else
            setIsFullscreen(false);
    }

    //<PowerBIEmbed embedConfig={embedConfig} eventHandlers={eventHandlers} cssClassName={"report-style-class"} getEmbeddedComponent={getEmbeddedComponent} />
    //<iframe height="100%" width="100%" src="https://app.powerbigov.us/reportEmbed?reportId=5a2f76c2-93aa-46a3-ab95-acd01bf3c06d&autoAuth=true&ctid=70af547c-69ab-416d-b4a6-543b5ce52b99&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLWdvdi1pb3dhLXJlZGlyZWN0LmFuYWx5c2lzLnVzZ292Y2xvdWRhcGkubmV0LyJ9" frameBorder="1" allowFullScreen={true}></iframe>
    return (
        <div>
            <Row>
                <Col>
                    <h1>Reports</h1>
                </Col>
            </Row>
            <Row style={{ flex: 1 }}>
                <Col>
                    {embedConfig ? (
                        <div className={isMaximzed ? "powerbi-report-container maximized" : "powerbi-report-container"} ref={reportContainer}>
                            <PowerBIEmbed embedConfig={embedConfig} eventHandlers={eventHandlers} cssClassName={"powerbi-report"} getEmbeddedComponent={getEmbeddedComponent} />
                            <div className="maximize">
                                <div onClick={toggleMaximized} className="action-icon">
                                    <FontAwesomeIcon icon={isMaximzed ? faCompress : faExpand} />
                                </div>
                            </div>
                        </div>
                    ) : null}
                </Col>
            </Row>
        </div>
    );
}

export default Reports;